import { useForm } from '@tanstack/react-form'

const useFormWrapper = <T>(props: { defaultValues: T }) =>
  useForm({
    defaultValues: props.defaultValues
  })

export type FormType<T> = ReturnType<typeof useFormWrapper<T>>
